import Repository from "../Repository";

const resource = "/deals";
export default {
    get(params, url, noPrefix = false) {
        if (url !== '') {
            if (noPrefix) { //for deallist
                return Repository.get(`${url}`, {params: params});

                // if (url.indexOf('?') !== -1) {
                //                     let search = url.indexOf('http') !== -1 ? new URL(url).search : '?' + url.split('?')[1];
                //                     return Repository.get(`${url}` + search, {params: params});
                //                 } else {
                //                     return Repository.get(`${url}`, {params: params});
                //                 }
            } else {
                let newUrl = new URL(url);
                return Repository.get(`${resource}` + newUrl.search, {params: params});
            }
        } else {
            return Repository.get(`${resource}`, {params: params});
        }
    },
    getDeal(dealId, params) {
        return Repository.get(`${resource}/${dealId}`, {params: params})
    },
    getAvailableDates() {
        return Repository.get(`/dates${resource}`)
    },
    getMissingDealIds() {
        return Repository.get(`${resource}/missing`)
    },
    create(json) {
        return Repository.post(`${resource}`, json);
    },
    updateDeal(dealId, json) {
        return Repository.put(`${resource}/${dealId}`, json);
    },
    deleteDeal(dealId) {
        return Repository.delete(`${resource}/${dealId}`);
    }
}